import React from 'react'
import { useSelector } from 'react-redux'
import { Route, Switch } from 'react-router'
import CardsPhysicalCards from 'src/app/Cards/CardsPhysicalCards'
import NotFoundBackgroundPageContent from 'src/components/NotFoundBackgroundPageContent/NotFoundBackgroundPageContent'
import { cardsRouteTree } from 'src/navigation/cardsRouteTree'
import { Rdrct } from 'src/navigation/Lnk'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'

const { rootPath, redirectTo, tabs } = cardsRouteTree.family
const physicalCardsPath = tabs[0].path

// Family page owns the nested routing; the non-tabbed shell is deliberate (src/page-components/AGENTS.md).
const CardsFamilyPage: React.FC = () => {
  const calculatedBackgroundLocation = useSelector(
    selectCalculatedBackgroundLocation,
  )

  return (
    <Switch location={calculatedBackgroundLocation}>
      <Route exact path={physicalCardsPath}>
        <CardsPhysicalCards />
      </Route>
      <Route exact path={rootPath}>
        <Rdrct to={redirectTo} />
      </Route>
      <Route path={'/'}>
        <NotFoundBackgroundPageContent />
      </Route>
    </Switch>
  )
}

export default CardsFamilyPage
